export default "__VITE_ASSET__DbalZWlq__"